import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {ErrorInfos} from './error-infos';
import {catchError} from 'rxjs/operators';
import {NotificationToastService} from '../services/notifications/notification-toast.service';
import {ToastErrorModel} from '../models/toasts/toast-error.model';

@Injectable({
  providedIn: 'root'
})
export class NetcoreUnauthorizedErrorInterceptorService implements HttpInterceptor{

  constructor(private notificationToastService: NotificationToastService) { }

  private static isNetcore401Error(err: HttpErrorResponse): boolean {
    return err.error && err.error['traceId'] != null && err.status == 401
  }

  private extractInfos(err: HttpErrorResponse) {
    return new Observable<any>(observer => {
      if (NetcoreUnauthorizedErrorInterceptorService.isNetcore401Error(err)) {
        observer.error(new ErrorInfos('Accès refusé', `Vous n'êtes pas autorisé à accéder à cette ressource.`));
      } else {
        observer.error(null)
      }
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erreurBrute: HttpErrorResponse) => {
        return this.extractInfos(erreurBrute).pipe(
          catchError((erreurDecodee: ErrorInfos) => {
            if (erreurDecodee != null) {
              this.notificationToastService.push(new ToastErrorModel(erreurDecodee.content, erreurDecodee.title));
            }
            return throwError(erreurBrute);
          }),
        ) }
      ),
    );
  }
}
